import {Buffer} from 'buffer'

export const getFile = (base64: any, fileName: string) => {
  const base64WithoutHeader = base64.split(',')[1]

  const byteCharacters = atob(base64WithoutHeader)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)

  const blob = new Blob([byteArray], {type: 'image/jpeg'})

  const file = new File([blob], `${fileName}.jpg`, {
    lastModified: new Date().getTime(),
    type: 'image/jpeg',
  })

  return file
}
